import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import PropTypes from 'prop-types';
import TableItem from './TableItem';
import AppTableContainer from '@projectK/components/AppTableContainer';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { TableCell, TableSortLabel, TableRow } from '@mui/material';
import { Fonts } from '@projectK/constants';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppTableLoader from '@projectK/components/AppTableLoader';
import AppTableNoData from '@projectK/components/AppTableNoData';
const WaiverTable = ({
  waivers,
  loading,
  fetchData,
  onDelete,
  verbiageSettings,
  titleSorting,
  setTitleSorting,
  descriptionSorting,
  setDescriptionSorting,
  signatureSorting,
  setSignatureSorting,
}) => {
  const companyTheme = CompanyTheme();

  const handleSort = (column) => {
    setTitleSorting(column === 'waiver_name' ? !titleSorting : null);
    setDescriptionSorting(
      column === 'description' ? !descriptionSorting : null,
    );
    setSignatureSorting(
      column === 'require_digital_signature' ? !signatureSorting : null,
    );
  };
  const canHideSortIcon = (column) => {
    const columnToState = {
      waiver_name: titleSorting,
      description: descriptionSorting,
      require_digital_signature: signatureSorting,
    };
    for (const columnName in columnToState) {
      if (columnName !== column && columnToState[columnName] !== null) {
        return true;
      }
    }
    return false;
  };

  return (
    <AppTableContainer className="app-table-container">
     <AppTableLoader loading={loading} className={'app-table-loader'}/>
        <AppScrollbar className='max-h'>
        <Table stickyHeader>
          <TableHead
            sx={{
              borderBottom: '0 none',
              '& .tableCell': {
                fontSize: 13,
                padding: 2,
                fontWeight: Fonts.BOLD,
                backgroundColor: companyTheme
                  ? companyTheme.primary.main
                  : '#211251',
                color: '#ffffff',
                '&:first-of-type': {
                  pl: 5,
                },
                '&:last-of-type': {
                  pr: 5,
                },
              },
            }}
          >
            <TableRow>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={titleSorting}
                  direction={titleSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('waiver_name')}
                  hideSortIcon={canHideSortIcon('waiver_name')}
                >
                  Title
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={descriptionSorting}
                  direction={descriptionSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('description')}
                  hideSortIcon={canHideSortIcon('description')}
                >
                  Text
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='center'>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
           <TableBody>
             {waivers.length > 0 ? (
               waivers.map((data) => (
                <TableItem
                  data={data}
                  key={data.id}
                  fetchData={fetchData}
                  onDelete={onDelete}
                  verbiageSettings={verbiageSettings}
                />
              ))
                 ) : (
             <AppTableNoData
               colSpan={3}
               message="No Waiver Setting Found"
               loading={loading}
               />
              )}
           </TableBody>
        </Table>
      </AppScrollbar>
    </AppTableContainer>
  );
};

export default WaiverTable;

WaiverTable.propTypes = {
  waivers: PropTypes.object,
  loading: PropTypes.bool,
  fetchData: PropTypes.func,
  onDelete: PropTypes.func,
  verbiageSettings: PropTypes.object,
  titleSorting: PropTypes.bool,
  setTitleSorting: PropTypes.func,
  descriptionSorting: PropTypes.bool,
  setDescriptionSorting: PropTypes.func,
  signatureSorting: PropTypes.bool,
  setSignatureSorting: PropTypes.func,
};
